export function nsParam(namespace) {
    return namespace.replace(/\\/g, '-')
}

export function paramNs(param) {
    return param.replace(/-/g, '\\')
}
